/**
 * The departure buttons of the «Где вы?» card for a trip to the museum (INV-PH-140, owner's QA 18.10.2026: a
 * tourist who types the placeholder example «Московский вокзал» had no idea the choice was theirs, and most
 * tourists start from the same five places). The facts — coordinates with their source and date, the meteor's
 * season end — live in `graphs/peterhof_plan/data/departure_points.json`; this is the read of them and the rule of
 * what is offered TODAY.
 *
 * A pick is committed exactly as a picked 2GIS suggestion is (`pickAndAsk`: `setAgentGeo` source `manual`, the
 * point's name as the label) — the visitor sees what they chose and so does the run.
 */

import data from '../../../graphs/peterhof_plan/data/departure_points.json';

export type DeparturePoint = {
  id: string;
  /** The button's words. */
  button: string;
  /** The place's name sent as `location_label` — what the trip says it starts from. */
  title: string;
  kind: 'train' | 'metro' | 'meteor';
  lat: number;
  lon: number;
  /** The last day (`YYYY-MM-DD`, Moscow time) the point is offered; none — all year. */
  until?: string;
};

const POINTS = data.points as DeparturePoint[];

/** The calendar day in Saint Petersburg as `YYYY-MM-DD` — the season dates of the data are local days. */
export function localDay(now: Date): string {
  return new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now);
}

/** The buttons to show on `now`: a point whose `until` has passed (the meteors after the end of navigation) is not offered. */
export function departureButtons(now: Date = new Date()): DeparturePoint[] {
  const today = localDay(now);
  return POINTS.filter((point) => !point.until || today <= point.until);
}

/** The `ask` the backend's «Где вы?» card carries for a trip to the museum (`graphs/peterhof_plan/tools/where.py`
 *  `ARRIVAL_ASK`; the two are held equal by `departurePoints.test.ts`). */
export const ARRIVAL_ASK = 'Как добраться до Петергофа от моего места?';

/** Only the card of a TRIP to the museum offers the departures: «что рядом со мной?» wants the visitor's own place. */
export function offersDepartures(ask: string | undefined): boolean {
  return ask === ARRIVAL_ASK;
}
